module.exports = __webpack_public_path__ + "static/media/share.67226bf4.svg";